module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921074149_T.49eb9fa0.jpg";